import { ConnectionPlanner } from '../components/planning/ConnectionPlannerMobile';
import { usePlanningStore } from '../stores/planningStore';
import { useNotifications } from '../components/providers/NotificationProvider';

export function Planning() {
  const { currentPlan, savePlan, loadPlan } = usePlanningStore();
  const { addNotification } = useNotifications();

  const handleSavePlan = () => {
    savePlan();
    addNotification({
      type: 'success',
      title: 'Plan Saved',
      message: 'Your connection plan has been saved successfully',
    });
  };

  const handleLoadPlan = (planId: string) => {
    loadPlan(planId);
    addNotification({
      type: 'success',
      title: 'Plan Loaded',
      message: 'Connection plan loaded successfully',
    });
  };

  return (
    <div className="h-full -mx-4 sm:-mx-6 lg:-mx-8 -my-4 sm:-my-6 lg:-my-8">
      <ConnectionPlanner
        onSave={handleSavePlan}
        onLoad={handleLoadPlan}
      />
    </div>
  );
}